import { render, staticRenderFns } from "./MaterialPropertyAdd.vue?vue&type=template&id=98e83154&scoped=true"
import script from "./MaterialPropertyAdd.vue?vue&type=script&lang=js"
export * from "./MaterialPropertyAdd.vue?vue&type=script&lang=js"
import style0 from "./MaterialPropertyAdd.vue?vue&type=style&index=0&id=98e83154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e83154",
  null
  
)

export default component.exports